/* eslint-disable max-len, no-plusplus */

const isProduction = window.location.origin.includes('universe.com')
const isConsentRevoked = () => !window.OnetrustActiveGroups?.includes('C0004')

const iframe = document.createElement('iframe')
iframe.setAttribute('id', 'tiktok-pixel-frame')
iframe.setAttribute('width', 0)
iframe.setAttribute('height', 0)
iframe.setAttribute('src', 'about:blank')
iframe.setAttribute('style', 'display:none')
document.body.appendChild(iframe)

const writeIframeContent = () => {
  // Don't render iframe if we don't have permission
  if (isProduction && isConsentRevoked()) return false

  const doc = iframe.contentWindow.document
  doc.open()
  doc.write(`
    <html>
      <head>
        <script>
          !function (w, d, t) {
            w.TiktokAnalyticsObject=t;var ttq=w[t]=w[t]||[];
            ttq.methods=["page","track","identify","instances","debug","on","off","once","ready","alias","group","enableCookie","disableCookie"];
            ttq.setAndDefer=function(t,e){t[e]=function(){t.push([e].concat(Array.prototype.slice.call(arguments,0)))}};
            for(var i=0;i<ttq.methods.length;i++)ttq.setAndDefer(ttq,ttq.methods[i]);
            ttq.instance=function(t){for(var e=ttq._i[t]||[],n=0;n<ttq.methods.length;n++)ttq.setAndDefer(e,ttq.methods[n]);return e};
            ttq.load=function(e,n){var i="https://analytics.tiktok.com/i18n/pixel/events.js";
            ttq._i=ttq._i||{},ttq._i[e]=[],ttq._i[e]._u=i,ttq._t=ttq._t||{},ttq._t[e]=+new Date,ttq._o=ttq._o||{},ttq._o[e]=n||{};
            var o=document.createElement("script");
            o.type="text/javascript",o.async=!0,o.src=i+"?sdkid="+e+"&lib="+t;
            var a=document.getElementsByTagName("script")[0];
            a.parentNode.insertBefore(o,a)};
          }(window, document, 'ttq');
        </script>
      </head>
    </html>
  `)
  return doc.close()
}

const removeIframeContent = () => {
  const doc = iframe.contentWindow.document
  doc.open()
  doc.write('')
  doc.close()
}

const initTiktokPixel = (tiktokPixelCodes) => {
  if (iframe.contentWindow.document.readyState === 'complete') {
    writeIframeContent()
  } else {
    iframe.onload = writeIframeContent
  }

  const iframeWindow = iframe.contentWindow
  let retries = 0

  const checkTtqAvailability = () => {
    if (iframeWindow.ttq) {
      const { ttq } = iframeWindow
      tiktokPixelCodes.forEach((code) => {
        ttq.load(code)
      })
      ttq.page()

      document.addEventListener('unii:tracking:tiktokpixel', (data) => {
        ttq.track(data.detail.command, data.detail.options)
      }, false)
    } else {
      if (retries++ > 5) return
      setTimeout(checkTtqAvailability, 500)
    }
  }

  checkTtqAvailability()
}

export default (tiktokPixelCodes) => {
  initTiktokPixel(tiktokPixelCodes)

  // Listenener for OneTrust consent changes
  window.OptanonWrapper = () => {
    if (isConsentRevoked()) {
      removeIframeContent()
    } else {
      initTiktokPixel(tiktokPixelCodes)
    }
  }
}
